import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHUkFAQBody from "./Components/BodyUKFAQ";

class CHUkFAQ extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHUkFAQBody />
        <Footer />
      </>
    );
  }
}

export default CHUkFAQ;
